<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<h1>Trashed Tasks</h1>
		</div>
		<div class="col-12">
			<div class="card table-responsive">
    			<table class="table mb-0">
    				<thead>
    					<th></th>
    					<th>Client</th>
    					<th>User</th>
    					<th>Preview</th>
    					<th>Deleted</th>
    					<th></th>
    				</thead>

    				<tr v-for="task in tasks">
    					<td>
    						<input type="checkbox" :value="task.id" v-model="ids">
    					</td>
    					<td>
    						<span v-html="task.client ? task.client.name : '<em>unknown client</em>'" />
    					</td>
    					<td>
							<span v-html="task.user ? task.user.display_name : '<em>unknown user</em>'" />
    					</td>
    					<td>
    						{{ task.title.substring(0, 40) + '...' }}
    					</td>
    					<td>
    						<span v-html="moment(task.deleted_at).format('MMM D, YYYY')" class="text-gray-500" />
    					</td>
    					<td>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Put Back'" @click="restoreItems(task.id)"><i class="fal fa-trash-undo text-gray-500"></i></button>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Permadelete'" @click="deleteItems(task.id)"><i class="fal fa-times-circle text-gray-500"></i></button>
    					</td>
    				</tr>

    				<tr>
    					<td>
    						<input type="checkbox" @click="toggleAll()">
    					</td>
    					<td colspan="5">
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="restoreItems()"><i class="fal fa-trash-undo mr-1"></i>Restore Items</button>
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="deleteItems()"><i class="fal fa-times-circle mr-1"></i>Permanently Delete</button>
    					</td>
    				</tr>
    			</table>
    		</div>
        </div>
    </div>
</div>	

</template>

<script>
	import BreadcrumbsManager from '../../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				tasks: null,

				ids: [],
			}
		},

		created() {
			this.fetchTrashedTasks();
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Trashed Items', to: { name: 'admin.trashed.tasks'} },
	            { text: 'Tasks', to: { name: ''} },
        	]);
		},


		methods: {
			deleteItems(id) {
				let ids = id ? [id] : this.ids;
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will *really* not be able to recover the item(s)',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Keep',
					animation: false,
				}).then((result) => {
					if (result.value) {
						this.data_loaded = false;
						axios.post('/api/tasks/trashed/delete', { ids: ids }).then(({data}) => {
							Swal.fire({
			                    toast: true,
			                    position: 'top-end',
			                    showConfirmButton: false,
			                    timer: 3000,
			                    icon: 'success',
			                    title: 'Items deleted',
			                });
			                this.fetchTrashedTasks();					
						});
					}
				});
			},

			fetchTrashedTasks() {
				axios.get('/api/tasks/trashed').then(({data}) => {
					this.tasks = data;
					this.data_loaded = true;
				})
			},

			restoreItems(id) {
				let ids = id ? [id] : this.ids;
				this.data_loaded = false;
				axios.post('/api/tasks/trashed/restore', { ids: ids }).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Items restored',
	                });
	                this.fetchTrashedTasks();					
				});
			},

			toggleAll() {
				if (this.ids.length > 0) {
					this.ids = [];
				} else {
					this.ids = this.tasks.map(task => task.id);
				}
			}
		},
	}
</script>